<template>
  <b-container fluid>
    <b-row id="topbar">
      <b-col cols="2">
        <img
          id="logo"
          class="m-2"
          :src="require('/static/images/logo_sgcq_w.png')"
          aria-label="Logomarca do SGCQ"
          width="130"
        />
      </b-col>
      <b-col cols="7">
        <p class="titulo-netech text-center m-3" aria-label="Título do SGCQ">
          Sistema Gerenciador de Controle e Qualidade
        </p>
      </b-col>
      <b-col cols="3">
        <store-loader class="m-3"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import StoreLoader from "@/components/supports/StoreLoader";

export default {
  name: "SgcqTopBar",

  components: {
    "store-loader": StoreLoader,
  },

  data() {
    return {};
  },

  methods: {},

  setup() {
    const store = useSgcqStore();
    return {
      store,
    };
  },
};
</script>

<style lang="scss" scoped>
#topbar {
  background-color: #112a4a;
}

.titulo-netech {
  font-size: 1.8rem;
  color: #fff;
}


</style>
